











































Currency = require 'models/currency.coffee'
require 'vendor.charts.js'

export default
  name: 'ForecastModal'
  components:
    balance: require('components/inside/elements/balance.vue').default
  props: ['surplus_amount', 'forecast']
  mounted: ->
    @$store.dispatch('hideTransactionsPopovers')
    @drawChart()
    @event = "keyup.#{this.$options.name}"
    $(window).off(@event).on @event, (e) =>
      @hide() if e.keyCode == 27
  methods:
    hide: -> @$emit('hide')
    showPlanningModal: ->
      @hide()
      @$store.dispatch('showPlanningModal')
    newTransfer: (surplus_or_deficit) ->
      @$store.dispatch 'calendarGoToMonth', new Date()
      f = =>
        @hide()
        attrs =
          type: 'unplanned'
          subtype: 't'
          transfer_type: 'v'
          real_amount: Math.abs(@surplus_amount)
          transfer_to_amount: Math.abs(@surplus_amount)
          transfer_from_id: (if surplus_or_deficit == 'surplus' then @$store.getters.rs.id else @$store.getters.hm.id)
          transfer_to_id  : (if surplus_or_deficit == 'surplus' then @$store.getters.hm.id else @$store.getters.rs.id)
        @$store.dispatch('initTransaction', attrs).then (new_transaction) =>
          @$store.dispatch('selectTransaction', new_transaction).then =>
            f = -> window.scroll(0, $("#current_transaction_popover").offset().top - 50)
            @$nextTick => (setTimeout f, 40)

      @$nextTick => (setTimeout f, 40)
    makeChart: ->
      chart = AmCharts.makeChart 'forecast_chart',
        pathToImages: '/amcharts-images/'
        language: 'ru'
        type: 'serial'
        fontFamily: 'Inter'
        fontSize: 12
        dataDateFormat: 'YYYY-MM-DD'
        categoryField: 'date'
        dataProvider: @forecast.forecast_by_days
        columnSpacing: 0
        startDuration: 1
        marginTop: 5
        marginRight: 0
        categoryAxis:
          parseDates: true
          gridPosition: 'start'
        legend: { enabled: false }
        chartCursor:
            categoryBalloonEnabled: true
            bulletsEnabled: true
            bulletSize: 20
            selectWithoutZooming: true
            selectionAlpha: 0
        balloon:
          "adjustBorderColor": true,
          "color": "#000000",
          "cornerRadius": 5,
          "fillColor": "#FFFFFF"
          "disableMouseEvents": false
          "fixedPosition": true
          fillAlpha: 0.9
          hideBalloonTime: 1000
          maxWidth: 300
        graphs: [{
          id: 'g1'
          "bullet": "round"
          "bulletBorderAlpha": 1
          "bulletColor": "#FFFFFF"
          "bulletSize": 5
          negativeLineColor: 'red'
          negativeFillColors: 'red'
          lineAlpha: 1
          lineThickness: 2
          lineColor: 'green'
          useLineColorForBulletBorder: true
          animationPlayed: true
          showHandOnHover: true
          balloonFunction: (item, graph) =>
            return '' if item.dataContext.trs.length == 0
            total_balance = item.dataContext.reserves_balance + @$store.getters.hm.balance + @$store.getters.goals_sum + @$store.getters.funds_sum
            res = "
            #{ @$t('Reserves') }: <b>#{Currency.format({value: item.dataContext.reserves_balance})}</b>,
            #{ @$t('Total') }: #{Currency.format({value: total_balance})}
              <table class='table is-marginless'>"
            for tr in item.dataContext.trs
              if tr.transfer_from_id == @$store.getters.rs.id
                tr = _.clone(tr)
                tr.plan_amount = -tr.plan_amount
              res += "
                <tr>
                  <td class='has-text-right is-narrow'>#{tr.fAmount({ color: true })}</td>
                  <td class='is-narrow'>#{tr.category || ''}</td>
                  <td style='white-space: nowrap;'>#{tr.fDescription()}</td>
                </tr>
              "
            res += "</table>"
            res
          "customBulletField": "customBullet"
          bulletSizeField: 'bulletSize'
          "valueField": "reserves_balance"
        }]
        chartScrollbar:
          graph: 'g1'
          scrollbarHeight: 40
          gridAlpha: 0
          color: '#888888'
          backgroundAlpha: 0
          selectedBackgroundAlpha: 0.1
          selectedBackgroundColor: '#888888'
          graphFillAlpha: 0
          autoGridCount: true
          selectedGraphFillAlpha: 0
          graphLineAlpha: 0.2
          graphLineColor: 'green'
          selectedGraphLineColor: 'green'
          selectedGraphLineAlpha: 1
      return chart
    drawChart: ->
      @chart = @makeChart()
      @zoomChart(@chartZoomLevel())
      @chart.addListener 'clickGraphItem', (event) =>
        return if HM.is_mobile
        @hide()
        @$store.dispatch 'calendarGoToMonth', event.item.dataContext.date
    zoomChart: (months) ->
      @chartZoomLevel months
      @chart.zoomToDates(hm_date.addMonths(new Date, -1), hm_date.addMonths(new Date, months))
    chartZoomLevel: (months) ->
      if months
        localStorage.setItem('forecast_chart_zoom_level', months)
        return months
      else
        localStorage.getItem('forecast_chart_zoom_level') || 3
